const INSTITUTIONAL_DOMAIN = "ferruginiadvogados.com.br";

export const normalizeInstitutionalEmail = (value: string): string => {
  const normalized = value.trim().toLowerCase();
  if (!normalized.includes("@")) return normalized;

  // Corrige variações comuns no domínio (ex.: ferrrugini, ferrrrugini)
  return normalized.replace(
    /@ferr+ruginiadvogados\.com\.br$/i,
    `@${INSTITUTIONAL_DOMAIN}`
  );
};
